import dayjs from 'dayjs';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import styled from 'styled-components';
import {
  formatNumberToKoreanRealTrade,
  formatPriceToKorean,
} from 'utils/formatUtil';

interface Props {
  isVisibleDay: boolean;
  isVisibleRealTradeTypeChart: boolean;
}
export const QuoteChartTooltip = ({
  active,
  payload,
  label,
  isVisibleRealTradeTypeChart,
  isVisibleDay,
}: TooltipProps<ValueType, NameType> & Props) => {
  if (active && payload && payload.length) {
    const payloadData = payload?.[0].payload;

    const { price, count, date, woodaebbangPrice } = payloadData;
    const formattedDate = dayjs(date).format(
      `YYYY년 MM월 ${isVisibleDay ? `DD일` : ''}`,
    );

    return (
      <TooltipBox>
        <YearMonth>{formattedDate}</YearMonth>

        <TradeTypePrice>
          단지표준가격{' '}
          {woodaebbangPrice ? formatPriceToKorean(woodaebbangPrice) : '-'}
        </TradeTypePrice>

        {isVisibleRealTradeTypeChart && (
          <TooltipText>
            실거래가 {price ? formatNumberToKoreanRealTrade(price) : '-'}
          </TooltipText>
        )}

        <TooltipText>실거래 건수 {count}건</TooltipText>
      </TooltipBox>
    );
  }

  return null;
};

const TooltipBox = styled.div`
  font-size: 0.8rem;
  background: #fff;
  padding: 14px 14px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 30, 81, 0.12),
    0px 0px 8px 0px rgba(0, 30, 81, 0.04);
  line-height: 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const TooltipText = styled.div`
  color: #333;
  font-weight: 400;
`;

const TradeTypePrice = styled.div`
  color: #4584ff;
  font-weight: 700;
`;

const YearMonth = styled.div`
  color: #333;
  font-weight: 700;
  letter-spacing: -0.24px;
`;
